'use strict'

var $ = require('jquery');

function ScrollTo(config) {
	this.config = $.extend({}, {
		triggerClass: 'scrollTrigger',
		defaultPadding: 20
	}, config);
	this.triggers = $('.' + this.config.triggerClass);
}

ScrollTo.prototype.activate = function () {
	if (!this.triggers.length) return;

	this.activateListeners();
};

ScrollTo.prototype.activateListeners = function () {
	var that = this;

	this.triggers.on('click.' + this.config.triggerClass, function(event) {
		event.preventDefault();
		var targetSection = $(this.href.slice(this.href.lastIndexOf('#')));
		var targetSectionTop = targetSection.offset().top;

		// Animate scroll to selected group
		$('html, body').animate({
			scrollTop: targetSectionTop - that.config.defaultPadding
		}, 'slow');
	});
};

module.exports = ScrollTo;
